import React, {
  useEffect,
  useCallback,
} from 'react';
import { useNavigate } from 'react-router';

import {
  getStatus,
} from 'redux-resource';

import {
  shallowEqual,
  useDispatch,
  useSelector,
} from 'react-redux';

import {
  coreActions,
  coreSelectors,
} from '@gymcloud/core';

import {
  uiActions,
} from 'web-actions';

import {
  Flex,
} from 'web-styled';

import {
  Button,
  Spinner,
  NotFound,
} from 'web-components';

import ClientDetailsList from '../ClientDetailsList';

interface Props {
  rootId: number
  clientInfo: any,
  resourceType: string,
}

const Documents = ({
  rootId,
  clientInfo,
  resourceType,
}: Props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      coreActions.requestClientPersonalEntity({
        clientId: clientInfo.id,
        entityType: 'assigned_documents',
        resourceType,
      }),
    );
  }, [clientInfo.id, resourceType]);

  const mapState = useCallback(state => ({
    items: coreSelectors.getClientTemplates(
      clientInfo.id,
      'documents',
    )(state),
    fetchingDocumentsStatus: getStatus(
      state,
      [
        'documents.requests.fetchDocuments.status',
      ],
      true,
    ),
    assigningStatus: getStatus(
      state,
      [
        'assignees.requests.assignDocumentToClient.status',
        'assignees.requests.unAssignDocumentToClient.status',
      ],
      false,
    ),
  }), [clientInfo.id, resourceType]);

  const {
    items,
    assigningStatus,
    fetchingDocumentsStatus,
  } = useSelector(mapState, shallowEqual);

  const onRequestDeleteItem = (id) => {
    const onConfirmAction = coreActions.requestUnAssignDocumentToClient({
      id,
      clientId: clientInfo.id,
    });

    dispatch(
      uiActions.confirmModal({
        modal: {
          title: 'Delete item',
          bodyText: 'Are you sure you want to delete selected items?',
        },
        onConfirmAction,
      }),
    );
  };

  return (
    <Flex fillSpace>
      {fetchingDocumentsStatus.pending && (
        <Spinner message="Loading..." />
      )}

      {assigningStatus.pending && (
        <Spinner over message="Assigning document..." />
      )}

      {fetchingDocumentsStatus.succeeded && (
        <Flex
          column
          fillSpace
          spacing={10}
        >
          <ClientDetailsList
            items={items}
            tabName="documents"
            onRequestDeleteItem={onRequestDeleteItem}
            emptyState={(
              <>
                <span>
                  <br />
                  No document currently assigned
                  <br />
                  to this client
                </span>
                <Button
                  ghost
                  appearance="primary"
                  onClick={() => {
                    navigate(`/documents_folder/${rootId}`);
                  }}
                >
                  See Document List
                </Button>
              </>
            )}
          />
        </Flex>
      )}

      {fetchingDocumentsStatus.failed && (
        <NotFound title="Loading failed" />
      )}
    </Flex>
  );
};

export default Documents;
